<template>
    <div class="modal fade" id="feedbackModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Signup for Updates</h5>
            <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-promo-bar"></div>
          <div class="modal-body pt-4 text-left">

            <p class="">Signup for updates and get the <strong>Carbon Fiber Premium Bundle for free!</strong></p>
            <p>All 90 gradients (and extra features) will be mailed to you after signing up.</p>

            <form 
              method="POST" 
              action="https://thecssking.us3.list-manage.com/subscribe/post?u=c6de8090344e9a71adfab3370&amp;id=5e65425831" 
              id="mc-embedded-subscribe-form" 
              name="mc-embedded-subscribe-form"
              @submit="checkForm"
            >
                <div class="input-group mb-3">
                    <input type="hidden" name="form-name" value="contact" />
                    <input type="email" class="form-control" name="EMAIL" placeholder="Enter Your Email Address" required />
                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-right px-4" type="submit" name="subscribe" >Subscribe</button>
                    </div>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_c6de8090344e9a71adfab3370_5e65425831" tabindex="-1" value=""></div>
                </div>
            </form>

          </div>
          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-link close-modal">No Thanks</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import localStorageTools from '@/util/localStorageTools.js'

export default {
    data(){
        return {
            showPreview: false,
            previewBackground: '',
        }
    },
    methods: {
      checkForm(e){
        this.setAsSubscriber();
        return true
      },
      setAsSubscriber(){
        if(localStorageTools.localStorageAvailable()){
          let myStorage = window.localStorage;
          localStorage.setItem('subscriber', 'true');
        }
      }
    },
}
</script>

<style lang="scss" scoped>
.modal {
  background-color: #333;
  background-color: rgba(0,0,0,.4);
  // background-image: repeating-linear-gradient(90deg, hsl(355,77%,74%) 0px, hsl(355,77%,74%) 70px,hsl(40,77%,74%) 70px, hsl(40,77%,74%) 140px,hsl(85,77%,74%) 140px, hsl(85,77%,74%) 210px,hsl(130,77%,74%) 210px, hsl(130,77%,74%) 280px,hsl(175,77%,74%) 280px, hsl(175,77%,74%) 350px,hsl(220,77%,74%) 350px, hsl(220,77%,74%) 420px,hsl(265,77%,74%) 420px, hsl(265,77%,74%) 490px,hsl(310,77%,74%) 490px, hsl(310,77%,74%) 560px);
  
  .modal-header {
    border-bottom: 0px;
  }
}
</style>